// exclude-from-index
import React from 'react';
import PropTypes from 'prop-types';
import { SVGIcon } from '../SVGIcon';
import { AlertBox, AlertContent, AlertText } from './Alert.styles';
import { ReactChildrenPropType } from '../../../lib/commonPropTypes';

function Alert(props) {
  const { children, textValue } = props;

  return (
    <AlertBox>
      <AlertContent>
        <div>
          <SVGIcon selectedIcon="coloredWarning" width="24px" height="24px" />
        </div>
        <AlertText>{children || textValue}</AlertText>
      </AlertContent>
    </AlertBox>
  );
}

Alert.propTypes = {
  /** children prop that renders the custom component  */
  children: ReactChildrenPropType,
  /** dynamic text value */
  textValue: PropTypes.string
};

Alert.defaultProps = {
  children: null,
  textValue: 'This is a warning alert — check it out!'
};

export default Alert;
